import { andList } from "@edgetier/client-components";
import { FunctionComponent, memo, useMemo } from "react";

import { formatItems } from "./anomaly-description-items.utilities";
import { IProps } from "./anomaly-description-items.types";
import "./anomaly-description-items.scss";

const AnomalyDescriptionItems: FunctionComponent<IProps> = ({ items, maximumItems = 3, quote }) => {
    const { excessPhrases, listedPhrases, isAbbreviated } = useMemo(() => formatItems(items, maximumItems), [
        items,
        maximumItems,
    ]);
    return (
        <>
            {andList(listedPhrases, { quote })}
            {isAbbreviated && <> and {excessPhrases} more terms</>}
        </>
    );
};

export default memo(AnomalyDescriptionItems);
